import { css } from '@emotion/react'
import { rem } from '@groovehq/internal-design-system/lib/util/strings'

const container = css`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const image = css`
  width: 120px;
  height: 120px;
`

const checkIcon = theme => css`
  min-height: 80px;
  font-size: 80px;
  color: ${theme.color.info[500]};
  background-color: ${theme.color.info[100]};
  border-radius: 40px;
`

const positionSubtitle = theme => css`
  font-size: ${theme.fontSize.small};
  span {
    margin-right: ${rem(4)};
    font-weight: ${theme.fontWeight.bold};
    font-style: italic;
  }
`

const subtitle = theme => css`
  max-width: 640px;
  margin: ${rem(6)} auto 0;
  color: ${theme.color.monochrome.black};
  font-size: ${theme.fontSize.x5large};
  line-height: ${theme.lineHeight.leadingSnug};
`

const button = theme => css`
  min-height: 48px;
  padding: ${rem(11)} ${rem(30)};
  font-weight: ${theme.fontWeight.medium};
  border-radius: 28px;
`

export const styles = {
  container,
  image,
  checkIcon,
  positionSubtitle,
  subtitle,
  button,
}
